import { useQuery } from '@tanstack/react-query';
import { usePricingApi } from './use-pricing-api';

export const QK_VARIANT_PRICING = (sku: string | null | undefined) =>
  ['pricing', 'variant', sku] as const;

// Nullable so callers can wire conditional state without breaking rules-of-hooks.
export function useVariantPricing(sku: string | null | undefined) {
  const { pricingApi } = usePricingApi();

  return useQuery({
    queryKey: QK_VARIANT_PRICING(sku),
    queryFn: () => {
      if (!sku) {
        throw new Error('SKU is required');
      }
      return pricingApi.variantPricing(sku);
    },
    enabled: !!sku,
  });
}
